import { useState } from "react";

const useUpdateLeftPosition = () => {
  const updateLeftPosition = (containers, left, width, height, nextIndex) => {
    var previousLeft = left;
    var previousWidth = width;
    containers.metaData.slice(nextIndex).map(container => {
      
      container.styles.left = {value:previousLeft + parseInt(previousWidth.slice(0,-2))};
      previousLeft = container.styles.left.value;
      previousWidth = container.styles.width.value;
      
    });
    containers.metaData.map(container => {
      container.styles.height = {value:height};
    });
  }
  return updateLeftPosition;
};

export default useUpdateLeftPosition;
